import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Clock, Flame, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export const PostContent = ({
  post, currentContent, currentPostType, isEditedFlag,
  isEditing, editContent, setEditContent, editPostType, setEditPostType,
  onSave, onCancel, saving, postTypeConfig,
}) => {
  if (isEditing) {
    return (
      <div className="px-4 pb-3">
        <div className="space-y-3">
          <Textarea
            value={editContent}
            onChange={(e) => setEditContent(e.target.value)}
            className="bg-black border-border text-white min-h-[100px] resize-none focus:border-primary"
            placeholder="What's on your mind?"
            data-testid={`edit-post-textarea-${post.id}`}
          />

          <div className="flex flex-wrap gap-2">
            {Object.entries(postTypeConfig).map(([type, typeConfig]) => {
              const TypeIcon = typeConfig.icon;
              return (
                <button
                  key={type}
                  onClick={() => setEditPostType(type)}
                  className={`px-3 py-1.5 text-xs flex items-center gap-1 border transition-colors ${
                    editPostType === type
                      ? 'bg-primary text-black border-primary'
                      : 'border-border text-muted-foreground hover:border-primary/50'
                  }`}
                >
                  <TypeIcon className="h-3 w-3" />
                  {typeConfig.label}
                </button>
              );
            })}
          </div>

          <div className="flex justify-end gap-2">
            <Button variant="ghost" size="sm" onClick={onCancel} className="text-muted-foreground hover:text-white">
              Cancel
            </Button>
            <Button
              size="sm"
              onClick={onSave}
              disabled={saving || !editContent.trim()}
              className="bg-primary text-black"
              data-testid={`save-edit-post-${post.id}`}
            >
              {saving ? (
                <><Loader2 className="h-4 w-4 mr-1 animate-spin" /> Saving...</>
              ) : (
                'Save Changes'
              )}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="px-4 pb-3">
      <p className="text-white whitespace-pre-wrap">{currentContent}</p>
      {isEditedFlag && <span className="text-xs text-muted-foreground italic">(edited)</span>}

      {currentPostType === 'workout' && post.stats && (
        <div className="mt-3 flex items-center gap-4 p-3 bg-white/5 rounded">
          {post.workout_title && <span className="text-primary font-medium">{post.workout_title}</span>}
          {post.stats.duration_minutes && (
            <span className="flex items-center gap-1 text-sm text-muted-foreground">
              <Clock className="h-4 w-4" /> {post.stats.duration_minutes} min
            </span>
          )}
          {post.stats.calories_burned && (
            <span className="flex items-center gap-1 text-sm text-muted-foreground">
              <Flame className="h-4 w-4" /> {post.stats.calories_burned} cal
            </span>
          )}
        </div>
      )}

      {post.image_url && (
        <img
          src={post.image_url.startsWith('/') ? `${API}${post.image_url}` : post.image_url}
          alt="Post"
          className="mt-3 rounded max-h-96 w-full object-cover"
        />
      )}
    </div>
  );
};
